import regular from './regular';
import bronze from './bronze';
import silver from './silver';
import gold from './gold';
import platinum from './platinum';
import diamond from './diamond';
import elite from './elite';

export default {
    regular,
    bronze,
    silver,
    gold,
    platinum,
    diamond,
    elite
}